module.exports = "/img/frame.svg?6e38ffb35e776f1d903e553fed023bc5";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/spinner/img/frame.svg
// module id = K8+J
// module chunks = 83